import gql from 'graphql-tag';

export const teamQuery = gql`
  query team($id: ID!) {
    team(id: $id) {
      id
      name
      imageUrl
      description
      slug
      canonicalUrl
      githubId
      teamMemberships {
        edges {
          node {
            isMaintainer
            user {
              amIAdmin
              username
              id
            }
          }
        }
      }
      company {
        id
        slug
        name
      }
      privateStackDecisions {
        count
      }
      members {
        count
      }
      stacks {
        count
      }
      stackApps {
        count
      }
    }
  }
`;
